export default () => {
  const accordionSelectorName = 'data-accordion-item';
  const accordionSelector = '[data-accordion-item]';

  const accordionButtonClassNameActive = 'accordion__button--active';
  const accordionButtonSelector = `.accordion__button${accordionSelector}`;
  const accordionButtonArray = $(accordionButtonSelector);

  const accordionDrawerSelector = `.accordion__drawer${accordionSelector}`;
  const accordionDrawerArray = $(accordionDrawerSelector);

  accordionButtonArray.each(function() {
    const accordionButton = $(this);
    const accordionButtonSelectorValue = accordionButton.attr(accordionSelectorName);
    const accordionDrawerSelector = '[' + accordionSelectorName + '="' + accordionButtonSelectorValue + '"]';
    const accordionDrawer = accordionDrawerArray.filter(accordionDrawerSelector);

    accordionButton.click(function() {
      accordionButton.toggleClass(accordionButtonClassNameActive);
      accordionDrawer.slideToggle();
    });
  });
};
